import styled, { css } from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { DecisionTreeButton } from '../../../common/buttonsComponents';

export const Container = styled.div`
  position: relative;
  height: 100%;
  flex-direction: column;
  display: flex;
  padding: 50px;
`;
export const InnerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 0 32px;
  margin-top: 25px;
`;

export const TagButton = styled(DecisionTreeButton)`
  position: relative;
  min-width: 30px;
  width: auto;
  margin: 5px;

  ${({ selected }) =>
    selected &&
    css`
      border: 1px solid ${colors.blue1};
      color: ${colors.blue1};
    `}
`;

export const TagIcon = styled.img`
  margin: 0 5px 0 0;
`;
